import { useEffect, useState } from 'react';
import { useRouter } from 'next/router';

import { useAuth } from '../../hooks/useAuth';
import { routes } from '../../routes/routes';
import { setPrevRoute } from '@/utils/prevRoute';

export function EnrollmentRoute({ children }) {
  const router = useRouter();
  const {
    status,
    authStatuses,
    enrollmentPhase,
    enrollmentPhases,
    signout,
    userPermissions,
  } = useAuth();
  const [isVerified, setIsVerified] = useState(false);

  useEffect(() => {
    if (status === authStatuses.SIGNED_OUT) {
      setPrevRoute(router.asPath);
      router.push(routes.login.path);
    } else if (status === authStatuses.SIGNED_IN) {
      router.push({ pathname: routes.nodes.path });
      setIsVerified(true);
    }
  }, [
    router,
    status,
    authStatuses,
    enrollmentPhase,
    enrollmentPhases,
    signout,
    userPermissions,
  ]);

  if (isVerified) {
    return children;
  } else {
    return null;
  }
}
